import { type ReactNode } from "react";

const PATHS: Record<string, string> = {
  building: "M3 21h18M5 21V7l8-4v18M19 21V11l-6-4",
  user: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  card: "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM2 10h20",
  check: "M9 12l2 2 4-4M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c2.4 0 4.58.94 6.2 2.47",
};

export function ChecklistItem({
  icon,
  children,
}: {
  icon: "building" | "user" | "card" | "check";
  children: ReactNode;
}) {
  return (
    <li className="flex items-center gap-3">
      <span className="shrink-0 w-9 h-9 rounded-lg bg-muted flex items-center justify-center text-muted-foreground">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d={PATHS[icon]} />
        </svg>
      </span>
      <span className="text-sm text-slate-700 leading-snug">{children}</span>
    </li>
  );
}
